var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 52,
    viewBox: "0 0 165 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4298 20.378H54.1079V0H61.4298C67.5359 0 71.2935 3.81384 71.2935 10.189C71.2935 16.5501 67.5359 20.378 61.4298 20.378ZM58.8049 16.2687H61.264C64.6901 16.2827 66.5689 14.608 66.5689 10.189C66.5689 5.75595 64.6901 4.09531 61.2087 4.08124H58.8049V16.2687Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4397 0V20.378H79.7427V0H84.4397Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.459 20.378H93.1375V0H100.459C106.566 0 110.323 3.81384 110.323 10.189C110.323 16.5501 106.566 20.378 100.459 20.378ZM97.8346 16.2687H100.294C103.72 16.2827 105.598 14.608 105.598 10.189C105.598 5.75595 103.72 4.09531 100.238 4.08124H97.8346V16.2687Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.811V38.1349H5.08179C8.18318 38.1349 9.83663 40.0428 9.84597 42.6684C9.83663 45.2846 8.1645 47.183 5.04443 47.183H2.4288V51.811H0ZM2.4288 45.1618H4.70813C6.53907 45.1524 7.36112 44.1135 7.36112 42.6684C7.36112 41.2045 6.53907 40.1939 4.70813 40.1939H2.4288V45.1618Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3734 51.811V38.1349H23.8022V49.7331H29.7808V51.811H21.3734Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5315 51.811H40.9346L45.6988 38.1349H48.688L53.4709 51.811H50.874L49.7436 48.4297H44.6525L43.5315 51.811ZM45.3064 46.4463H49.0897L47.2495 40.9306H47.1374L45.3064 46.4463Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4014 40.1939V38.1349H73.1815V40.1939H69.0152V51.811H66.5864V40.1939H62.4014Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6529 51.811V38.1349H93.3219V40.1939H87.0817V43.934H92.724V45.993H87.0817V51.811H84.6529Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.012 44.9729C117.021 49.3931 114.35 51.9999 110.809 51.9999C107.25 51.9999 104.597 49.3837 104.606 44.9729C104.597 40.5528 107.25 37.946 110.809 37.946C114.35 37.946 117.021 40.5528 117.012 44.9729ZM107.054 44.9729C107.045 48.0992 108.605 49.7898 110.809 49.7898C113.023 49.7898 114.574 48.0992 114.565 44.9729C114.574 41.8467 113.023 40.1561 110.809 40.1561C108.605 40.1561 107.045 41.8467 107.054 44.9729Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.745 51.811V38.1349H133.827C136.928 38.1349 138.582 39.8917 138.591 42.4984C138.582 44.359 137.741 45.738 136.153 46.3897L139.077 51.811H136.368L133.715 46.8052H131.174V51.811H128.745ZM131.174 44.7463H133.453C135.284 44.7557 136.106 43.9624 136.106 42.4984C136.106 41.0439 135.284 40.1939 133.453 40.1939H131.174V44.7463Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.249 38.1349H153.238L157.255 48.0708H157.423L161.44 38.1349H164.43V51.811H162.094V42.404H161.963L158.208 51.7732H156.471L152.715 42.3662H152.603V51.811H150.249V38.1349Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPWhite);
export default __webpack_public_path__ + "static/media/logo-p-white.3315ffa33f6bd76bcfb49484135f01dd.svg";
export { ForwardRef as ReactComponent };